import * as THREE from 'three';
import type { BuiltVehicle } from './style.js';
import { Track, type Pose } from './track.js';

/** A vehicle on the track: smooths server progress into motion, spins wheels, bounces on nitro. */
export class VehicleActor {
  readonly root = new THREE.Group();
  private built: BuiltVehicle | null = null;
  target = 0;
  progress = 0;
  /** Track units per second, for engine pitch and wheel spin. */
  speed = 0;
  private bounce = 0;
  private pose: Pose = { position: new THREE.Vector3(), tangent: new THREE.Vector3() };
  private lookTarget = new THREE.Vector3();

  constructor(
    public readonly id: string,
    public lane: number,
  ) {}

  setBuilt(b: BuiltVehicle): void {
    if (this.built) this.root.remove(this.built.root);
    this.built = b;
    this.root.add(b.root);
  }

  private stallLeft = 0;

  nitro(): void {
    this.bounce = 1;
  }

  /** Freeze forward motion briefly (typo penalty). */
  stall(ms: number): void {
    this.stallLeft = ms / 1000;
  }

  snap(progress: number): void {
    this.target = progress;
    this.progress = progress;
  }

  update(dt: number, track: Track): void {
    const before = this.progress;
    const diff = this.target - this.progress;
    if (this.stallLeft > 0) this.stallLeft -= dt;
    else {
      // Ease towards the authoritative progress; never overshoot.
      this.progress += diff * Math.min(1, dt * 5);
      if (Math.abs(diff) < 1e-5) this.progress = this.target;
    }
    const dist = (this.progress - before) * track.length;
    this.speed = dt > 0 ? dist / dt : 0;

    track.pose(this.progress, this.lane, this.pose);
    this.root.position.copy(this.pose.position);
    this.lookTarget.copy(this.pose.position).add(this.pose.tangent);
    this.root.lookAt(this.lookTarget);

    if (this.built) {
      for (const w of this.built.wheels) w.rotation.x += dist / 0.45;
      this.bounce = Math.max(0, this.bounce - dt * 2.5);
      const b = Math.sin(this.bounce * Math.PI) * 0.35;
      this.built.root.position.y = b;
      this.built.root.rotation.x = -b * 0.4;
    }
  }
}
